import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { EstadoSituacionComponent } from './components/estado-situacion/estado-situacion.component';
import { AuthGuard } from './guard/auth.guard';
import { TokenGuard } from './guard/token.guard';
import { MensajeClienteExisteComponent } from './components/estado-situacion/mensaje-cliente-existe/mensaje-cliente-existe.component';
import { MensajeExitosoComponent } from './components/estado-situacion/mensaje-exitoso/mensaje-exitoso.component';
import { MensajeWarningComponent } from './components/estado-situacion/mensaje-warning/mensaje-warning.component';
import { PreguntasComponent } from './components/estado-situacion/preguntas/preguntas.component';
import { EdicionEstadoSituacionComponent } from './components/estado-situacion/edicion-estado-situacion/edicion-estado-situacion.component';

const login = 'login-eess';
export const routes: Routes = [
  {
    path: 'estado-situacion',
    children: [
      {
        path: '',
        redirectTo: login,
        pathMatch: 'full'
      },
      {
        path: 'preguntas',
        component: PreguntasComponent,
        canActivate: [AuthGuard]
      },
      {
        path: login,
        component: EstadoSituacionComponent
      },
      {
        path: 'error',
        component: MensajeWarningComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'exito',
        component: MensajeExitosoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'cliente',
        component: MensajeClienteExisteComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'edicion',
        component: EdicionEstadoSituacionComponent,
        canActivate: [AuthGuard, TokenGuard]
      },
      {
        path: '**',
        redirectTo: login
      }
    ]
  },
  {
    path: '',
    redirectTo: 'estado-situacion/login-eess',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
